module.exports = __webpack_public_path__ + "static/media/ibu-27.4a2dc816.png";